export const getSubmissionSections = (submission) => {
    const user = submission?.api?.user;
    const sections = [...(Array.isArray(user?.sections) ? user.sections : []), user?.section];
    const uniqueSections = new Map();
    sections.forEach((section) => {
        if (section?.id == null || section.id === '') return;
        const id = String(section.id);
        if (!uniqueSections.has(id)) uniqueSections.set(id, { id, name: section.name || id });
    });
    return [...uniqueSections.values()];
};

// Submission visibility is enforced upstream; allowed IDs also restrict multi-section TA choices.
export const getGradingSectionOptions = (submissions = [], allowedSectionIds) => {
    const allowedIds = allowedSectionIds && new Set(allowedSectionIds.map(String));
    const sections = new Map();
    submissions.forEach((submission) => {
        getSubmissionSections(submission).forEach(({ id, name }) => {
            if (allowedIds && !allowedIds.has(id)) return;
            const section = sections.get(id) ?? { id, name, count: 0 };
            sections.set(id, { ...section, count: section.count + 1 });
        });
    });
    return [...sections.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
};

export const filterNavigationOptions = (options = [], sectionId = '') =>
    options
        .filter((option) => !sectionId || option.sections?.some(({ id }) => String(id) === String(sectionId)))
        .map((option, index) => ({ ...option, number: index + 1 }));

export const isGroupGradingAssignment = (assignment) => {
    const data = assignment?.api_data;
    return Boolean((data?.group_category_id && data.grade_group_students_individually !== true) || data?.GroupTypeId);
};

export const getGradingNavigationTitle = (submission, assignment) =>
    (isGroupGradingAssignment(assignment) ? submission?.api?.group?.name : undefined) ??
    submission?.api?.user?.name ??
    submission?.files?.[0]?.original_file?.name ??
    submission?.files?.[0]?.name ??
    String(submission?.api?.user?.id ?? '');

export const sortNavigationOptions = (options = [], sort = 'default', isUnscored = false) =>
    [...options].sort((a, b) => {
        if (sort === 'default' || sort === 'title-asc' || sort === 'title-desc') {
            const order = (a.value ?? '').localeCompare(b.value ?? '', undefined, { numeric: true });
            return sort === 'title-desc' ? -order : order;
        }
        if (isUnscored || !['grade-asc', 'grade-desc'].includes(sort)) return 0;
        const direction = sort === 'grade-desc' ? -1 : 1;
        for (const field of ['actualGrade', 'suggestedGrade']) {
            const gradeA = a[field] ?? null;
            const gradeB = b[field] ?? null;
            if (gradeA !== null && gradeB !== null) return direction * (gradeA - gradeB);
            if (gradeA !== null) return -1;
            if (gradeB !== null) return 1;
        }
        return 0;
    });
